var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.86891 10.1021C2.93839 9.42114 2.20997 8.62651 1.73525 8C2.20997 7.37349 2.93839 6.57886 3.86891 5.89788C5.00795 5.06429 6.41053 4.42857 8.00001 4.42857C9.58948 4.42857 10.9921 5.06429 12.1311 5.89788C13.0616 6.57886 13.79 7.37349 14.2648 8C13.79 8.62651 13.0616 9.42114 12.1311 10.1021C10.9921 10.9357 9.58948 11.5714 8.00001 11.5714C6.41053 11.5714 5.00795 10.9357 3.86891 10.1021ZM8.00001 3C6.01864 3 4.32649 3.79285 3.02546 4.74498C1.72646 5.69562 0.778205 6.8325 0.2641 7.60379L0 8L0.2641 8.39621C0.778205 9.1675 1.72646 10.3044 3.02546 11.255C4.32649 12.2071 6.01864 13 8.00001 13C9.98137 13 11.6735 12.2071 12.9746 11.255C14.2736 10.3044 15.2218 9.1675 15.7359 8.39621L16 8L15.7359 7.60379C15.2218 6.8325 14.2736 5.69562 12.9746 4.74498C11.6735 3.79285 9.98137 3 8.00001 3ZM8.00009 10.8574C9.57779 10.8574 10.8568 9.57817 10.8568 8.00021C10.8568 6.42225 9.57779 5.14307 8.00009 5.14307C6.42239 5.14307 5.14341 6.42225 5.14341 8.00021C5.14341 9.57817 6.42239 10.8574 8.00009 10.8574Z",
    fill: "#626262"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShow);
export default __webpack_public_path__ + "static/media/show.f78a6a372ae15d02541d38d284ca8662.svg";
export { ForwardRef as ReactComponent };